import { apiClient, get, post, URL } from "./index";

// =================================================================
// TIPOS
// =================================================================

export interface UploadThingFile {
  id: string;
  key: string;
  name: string;
  status: "Uploaded" | "Processing" | "Failed";
  size: number;
  uploadedAt: number;
}

export interface UploadThingResponse {
  key: string;
  url: string;
  name: string;
  size: number;
}

export interface ListFilesResponse {
  hasMore: boolean;
  files: UploadThingFile[];
}

export interface FileStatusResponse {
  fileData: {
    fileKey: string;
    fileName: string;
    fileSize: number;
    fileType: string;
    fileUrl: string;
    ufsUrl: string;
  };
  status: string;
}

// =================================================================
// CRUD UPLOADTHING
// =================================================================

/**
 * GET - Lista todos os arquivos OU busca um específico
 */
export async function getFiles(fileKey?: string): Promise<ListFilesResponse | FileStatusResponse> {
  if (fileKey) {
    // Busca arquivo específico
    const url = `${URL.out.API_AVATAR_URL}pollUpload/${fileKey}`;
    const response = await get<FileStatusResponse>(apiClient.avatar, url);
    return response.data;
  } else {
    // Lista todos
    const url = `${URL.out.API_AVATAR_URL}listFiles`;
    const response = await post<ListFilesResponse>(apiClient.avatar, url, {});
    return response.data;
  }
}

/**
 * POST - Faz upload de um arquivo (substitui se já existir)
 */
export async function uploadFile(file: File, customName?: string): Promise<UploadThingResponse> {
  const fileName = customName || file.name;
  
  // 1. Lista todos os arquivos para verificar se já existe
  const allFiles = await getFiles() as ListFilesResponse;
  const existingFile = allFiles.files.find(f => f.name === fileName);
  
  // 2. Se existe, deleta primeiro
  if (existingFile) {
    await deleteFiles([existingFile.key]);
  }
  
  // 3. Faz o upload usando o apiClient.avatar que já tem a autenticação configurada
  const formData = new FormData();
  const finalFile = customName 
    ? new File([file], customName, { type: file.type })
    : file;
    
  formData.append("files", finalFile);

  const url = `${URL.out.API_AVATAR_URL}upload`;
  const response = await apiClient.avatar.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const result = response.data;
  return Array.isArray(result) ? result[0] : result;
}

/**
 * DELETE - Remove arquivos
 */
export async function deleteFiles(fileKeys: string[]): Promise<void> {
  const url = `${URL.out.API_AVATAR_URL}deleteFiles`;
  await post<unknown>(apiClient.avatar, url, { fileKeys });
}

